<template>
  <div @click="handleClick"> 
    <!-- Navbar -->
    <NavbarComponent v-if="showNavbar" />
    <musicaFondo v-if="showmusicaFondo" />
        <mispadres v-if="showmispadres" />

    <faltan v-if="showfaltan" />
    <carruselComponent v-if="showcarrusel" />

    <!-- Imagen de portada -->
    <quotemensaje v-if="showquotemensaje" />
                <intermedio v-if="showintermedio" />

        <dondeycuando v-if="showdondeycuando" />

    <imagenprimera v-if="showimagenprimera" />
    <BienvenidaPage v-if="showBienvenida" />








    <itinerario v-if="showitinerario" />


    <mensajeregalos v-if="showmensajeregalos" />


    <!-- Comprobar si idInvitado es válido antes de mostrar el componente InvitadoEvento -->
    <Codigovestimenta v-if="showcodigovestimenta" />
            <Fotito v-if="showfotito" />

    <mesaRegalos v-if="showmesaRegalos" />
            <carruselcomponent2 v-if="showcarrusel2" />

    <carrusel3 v-if="showcarrusel3" />
    <imagensegunda v-if="showimagensegunda" />

    <InvitadoEvento 
      v-if="showInvitadoEvento && isValidIdInvitado" 
      :id-invitado="Number(idInvitado)" 
      :nombre="nombreVariable" 
      :id-festejado="Number(idFestejado)" 
    />
  
    <confirmacionasistencia
      v-if="showInvitadoEvento && isValidIdInvitado" 
      :id-invitado="Number(idInvitado)" 
      :nombre="nombreVariable" 
      :id-festejado="Number(idFestejado)" 
    />
        <Carruselfina v-if="showcarrusefinal" />

    <blogevento
      v-if="showblogevento"
      :id-invitado="Number(idInvitado)" 
      :nombre="nombreVariable" 
      :id-festejado="Number(idFestejado)" 
    />
 
   <hashtag
      v-if="showInvitadoEvento && isValidIdInvitado" 
      :id-invitado="Number(idInvitado)" 
      :nombre="nombreVariable" 
      :id-festejado="Number(idFestejado)" 
    />
    <Mensajefinal v-if="showmensajefinal" />
    <carruselfina v-if="showcarrusefina" />

    <imgfinal v-if="showimgfinal" />
    <img_fixed v-if="showimg_fixed" />
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, watch, computed } from 'vue';
import { useRoute } from 'vue-router';
import NavbarComponent from './narvar_ingles.vue';
import BienvenidaPage from './BienvenidaPage_ingles.vue';
import imagenprimera from './imagenprimera_ingles.vue';
import dondeycuando from './dondeycuando_ingles.vue';
import quotemensaje from './quotemensaje_ingles.vue';
import itinerario from './itinerario_ingles.vue';
import carruselComponent from './carruselComponent_ingles.vue';
import mensajeregalos from './mensajeregalos_ingles.vue';
import InvitadoEvento from './invitado_evento_ingles.vue';
import confirmacionasistencia from './confirmaciónasistencia_ingles.vue';
import blogevento from './blog_evento_ingles.vue';
import imgfinal from './imgfinal_ingles.vue';
import img_fixed from './img_fixed_ingles.vue';
import musicaFondo from './musica_fondo_ingles.vue';
import mesaRegalos from './regalos_ingles';
import carruselcomponent2 from './carruselcomponent2_ingles.vue';
import Carruselcomponent2 from './carruselcomponent2_ingles.vue';
import faltan from './faltan_ingles.vue';
import carrusel3 from './carrusel3_ingles.vue';
import codigovestimenta from './codigovestimenta_ingles.vue';
import imagensegunda from './imagenSegunda_ingles.vue';
import Carruselfina from './carruselfina_ingles.vue';
import mispadres from './mispadres_ingles.vue';
import Mensajefinal from './mensajefinal_ingles.vue';
import intermedio from './intermedio_ingles.vue';
import hashtag from './hashtag_ingles.vue';
import Fotito from './fotito_ingles.vue';
import carruselfina from './carruselultimo_ingles.vue';
export default {
  name: 'BaseB',
  components: {
    NavbarComponent,
    BienvenidaPage,
    Carruselfina,
    imagenprimera,
    Fotito,
    Mensajefinal,
    carruselfina,
    imagensegunda,
    faltan,
    dondeycuando,
    itinerario,
    carrusel3,
        hashtag,

    carruselComponent,
    carruselcomponent2,
    mensajeregalos,
    mispadres,
    mesaRegalos,
    InvitadoEvento,
    confirmacionasistencia,
    intermedio,
    quotemensaje,
    blogevento,
    imgfinal,
    codigovestimenta,
    img_fixed,
    musicaFondo,
    Carruselcomponent2,
  },
  setup() {
    const showNavbar = ref(false);
    const showBienvenida = ref(false);
    const showimagenprimera=ref(false);
    const showdondeycuando=ref(false);
const showcarrusel3=ref(false);
    const showitinerario=ref(false);
    const showcarrusel=ref(false);
   const showcarrusefinal=ref(false);
    const showmensajeregalos=ref(false);
    const showmesaRegalos=ref(false);
    const showInvitadoEvento=ref(false);
    const showconfirmacionasistencia=ref(false);
    const showquotemensaje=ref(false);
        const showhashtag=ref(false);
const showfotito=ref(false);
const showcarrusefina=ref(false);
    const showblogevento=ref(false);
    const showimgfinal=ref(false);
    const showimg_fixed=ref(false);
    const showmusicaFondo=ref(false);
    const showcodigovestimenta=ref(false);
    const showfaltan=ref(false);
    const showcarrusel2=ref(false);
    const showmispadres=ref(false);
    const showimagensegunda=ref(false);
    const showintermedio=ref(false);
    const showmensajefinal=ref(false);


    // Obtener el parámetro idInvitado de la ruta
    const route = useRoute();
    const idInvitado = ref(Number(route.params.idInvitado) || undefined); // Si no hay parámetro, es undefined
    const idFestejado = ref(Number(route.params.idFestejado) || undefined); // Si no hay parámetro, es undefined
    const nombreVariable = ref(route.params.nombre) ;

    // Verificar si el idInvitado es válido (no NaN o undefined)
    const isValidIdInvitado = computed(() => {
      return !isNaN(idInvitado.value) && idInvitado.value !== undefined;
    });

    const isValidFestejado = computed(() => {
      return !isNaN(idIFestejado.value) && idFestejado.value !== undefined;
    });


    // Observa los cambios en la ruta para actualizar idInvitado
    watch(() => route.params.idInvitado, (newId) => {
  idInvitado.value = Number(newId);
});

watch(() => route.params.idFestejado, (newId) => {
  idFestejado.value = Number(newId);
});
watch(() => route.params.nombre, (newId) => {
  nombreVariable.value = (newId);
});

    const handleClick = () => {
      console.log('idInvitado:', idInvitado.value); // Verifica el valor aquí
      console.log('idFestejado:', idFestejado.value); // Verifica el valor aquí
      console.log('NOMBRE:', nombreVariable.value); // Verifica el valor aquí

      showNavbar.value = true;
      showBienvenida.value = true;
      showimagenprimera.value=true;
      showdondeycuando.value = true;
      showitinerario.value = true;
            showhashtag.value=true;
showfotito.value=true;
      showcodigovestimenta.value=true;
      showcarrusel.value = true;
      showimagensegunda.value=true;
      showcarrusefina.value=true;
      showmensajeregalos.value = true;
      showmesaRegalos.value=true;
      showcarrusefinal.value=true;
      showmispadres.value=true;
      showInvitadoEvento.value = true;
      showconfirmacionasistencia.value = true;
      showquotemensaje.value=true;
      showmensajefinal.value=true;
      showcarrusel3.value=true;
      showfaltan.value=true;
      showblogevento.value=true;
      showcarrusel2.value=true;
      showimgfinal.value=true;
      showintermedio.value=true;
      showimg_fixed.value = true;
      showmusicaFondo.value=true;
    };

    onMounted(() => {
      document.addEventListener('click', handleClick);
    });

    onUnmounted(() => {
      document.removeEventListener('click', handleClick);
    });

    return {
      showNavbar,
      showimagenprimera,
      showdondeycuando,
      showitinerario,
      showmensajeregalos,
      showcodigovestimenta,
      showInvitadoEvento,
      
      showquotemensaje,
      showimgfinal,
      showfotito,
      showimg_fixed,
      showmusicaFondo,
      showfaltan,
      showcarrusefinal,
      idInvitado,
      showcarrusefina,
      isValidIdInvitado, 
      showcarrusel2,
      showcarrusel,
      idFestejado,
showmesaRegalos,
      showmispadres,
      nombreVariable,
      isValidFestejado, // Computed que indica si el idInvitado es válido
      handleClick,
    };
  }
};
</script>

<style scoped>
/* Estilos globales para el contenedor */
</style>
